import Vue from "vue";
import Router from "vue-router";
import i18n, { changeLocale, SUPPORTED_LANGUAGES } from "./i18n/i18n";
import PageWrapper from "./views/PageWrapper.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:lang/projekt/:projectSlug",
      name: "projekt",
      component: PageWrapper
    },
    {
      path: "/:lang/project/:projectSlug",
      name: "project",
      component: PageWrapper
    },
    {
      path: "/:lang/:pageSlug?",
      name: "pageWrap",
      component: PageWrapper
    },
    {
      path: "*",
      redirect: {
        name: "pageWrap"
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const lang = to.params.lang;
  if (!lang || !SUPPORTED_LANGUAGES.includes(lang)) {
    //check if local storage has locale
    const storedLocale = Vue.$localStorage.get("locale");
    const lang = SUPPORTED_LANGUAGES.includes(storedLocale)
      ? storedLocale
      : process.env.VUE_APP_I18N_FALLBACK_LOCALE;
    const params = { ...to.params, lang };
    return next({ path: "/" + lang + to.path, params });
  }
  if (i18n.locale !== lang) {
    changeLocale(lang);
  }
  return next();
});

export default router;
